module.exports = __webpack_public_path__ + "static/media/README.6a8f501f.md";